module.exports = __webpack_public_path__ + "img/dInvisible.c56bd3f5.png";